import { ReactNode } from "react"
import { ToolType } from "store/apis/toolsAPI/values.ts"
import { ElixirType } from "store/apis/elixirsAPI/values"
import {
  CyclesIcon,
  ShovelWithShadow,
  preformIcon,
  preformStackIcon
} from "assets/icons/index.ts"
import {
  ElixirSpeed1Img,
  ElixirSpeed2Img,
  ElixirSpeed3Img,
  ElixirStamina1Img,
  ElixirStamina2Img,
  ElixirStamina3Img
} from "assets/images/index.ts"

export const inventoryItemImgs: Record<
  ElixirType | "genesisPreform" | "tool",
  Record<string, string | ReactNode>
> = {
  [ElixirType.SPEED]: {
    default: <img src={ElixirSpeed1Img} alt="elixir speed 1" />,
    "Lvl 1": <img src={ElixirSpeed1Img} alt="elixir speed 1" />,
    "Lvl 2": <img src={ElixirSpeed2Img} alt="elixir speed 2" />,
    "Lvl 3": <img src={ElixirSpeed3Img} alt="elixir speed 3" />
  },
  [ElixirType.ENDURANCE]: {
    default: <CyclesIcon />,
    "Lvl 1": <img src={ElixirStamina1Img} alt="elixir stamina 1" />,
    "Lvl 2": <img src={ElixirStamina2Img} alt="elixir stamina 2" />,
    "Lvl 3": <img src={ElixirStamina3Img} alt="elixir stamina 3" />
  },
  [ElixirType.LUCK]: {
    default: <img src={ElixirSpeed1Img} alt="elixir speed 1" />,
    "Lvl 1": <img src={ElixirSpeed1Img} alt="elixir speed 1" />,
    "Lvl 2": <img src={ElixirSpeed2Img} alt="elixir speed 2" />,
    "Lvl 3": <img src={ElixirSpeed3Img} alt="elixir speed 3" />
  },
  genesisPreform: {
    icon: preformIcon,
    stackIcon: preformStackIcon
  },
  tool: {
    Shovel: <ShovelWithShadow />,
    [ToolType.WOODEN]: <ShovelWithShadow />,
    [ToolType.STEEL]: <ShovelWithShadow />,
    [ToolType.TITANIUM]: <ShovelWithShadow />,
    [ToolType.DIAMOND]: <ShovelWithShadow />,
    Wooden: <ShovelWithShadow />,
    Steel: <ShovelWithShadow />,
    Titanium: <ShovelWithShadow />,
    Diamond: <ShovelWithShadow />,
    default: <ShovelWithShadow />
  }
}
